/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// File: assets/custom.js
document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector(".Slideshow__Carousel");

  if (!slideshow) return;

  // Flickity instance
  const flkty = new Flickity(slideshow, {
    autoPlay: slideshow.dataset.flickityConfig ? JSON.parse(slideshow.dataset.flickityConfig).autoPlay : false,
    wrapAround: true,
    pageDots: true,
  });

  flkty.on("select", () => {
    const slides = document.querySelectorAll(".Slideshow__Slide");
    const selectedSlide = slides[flkty.selectedIndex];

    slides.forEach((slide) => {
      const video = slide.querySelector("video");
      const videoContainer = slide.querySelector(".Slideshow__VideoContainer");
      const imageContainer = slide.querySelector(".Slideshow__ImageContainer");

      if (slide === selectedSlide) {
        // Handle active slide
        if (video && videoContainer && imageContainer) {
          videoContainer.style.display = "block";
          imageContainer.style.display = "none";
          video.play();

          // Switch to image after 10 seconds
          setTimeout(() => {
            video.pause();
            videoContainer.style.display = "none";
            imageContainer.style.display = "block";
          }, 10000);
        }
      } else {
        // Reset all inactive slides
        if (video) video.pause();
        if (videoContainer) videoContainer.style.display = "none";
        if (imageContainer) imageContainer.style.display = "block";
      }
    });
  });
});
